import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { listCreditTransactionHistoryPerProduct } from 'services/apiCreditTransactions'

const useListCreditTransPerProduct = () => {
  const {isPending,isSuccess,isError,error,data} = useQuery({
    queryKey:['creditHistoryPerProduct'],
    queryFn:()=> listCreditTransactionHistoryPerProduct(),
    keepPreviousData:true,
    staleTime: 2 * 60 * 60 * 1000,
  })

  return {isPending,isSuccess,isError,error,data}
}

export default useListCreditTransPerProduct
